import {combineReducers} from "redux";
import result from "./result";
import draw from "./draw";
import resultHistory from "./resultHistory";
const resultReducer = combineReducers({
    result, resultHistory, draw
});

export default resultReducer;
